var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmexCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 25,
    viewBox: "0 0 39 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_6361)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M35.9108 0.0625H3.11996C1.37523 0.0625 0.0410156 1.41105 0.0410156 3.17453V21.8156C0.0410156 23.5791 1.47786 24.9276 3.11996 24.9276H35.9108C37.6555 24.9276 38.9897 23.5791 38.9897 21.8156V3.16416C38.9794 1.40067 37.5426 0.0625 35.9108 0.0625Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9098 1.10022C37.0388 1.10022 37.9625 2.03383 37.9625 3.17491V21.816C37.9625 22.9571 37.0388 23.8907 35.9098 23.8907H3.11904C1.99009 23.8907 1.06641 22.9571 1.06641 21.816V3.16453C1.06641 2.02345 1.99009 1.08984 3.11904 1.08984H35.9098",
    fill: "#286CB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23651 10.6946L10.0268 12.6345H8.44625L9.23651 10.6946ZM25.7089 10.7776H22.6607V11.6386H25.6576V12.9249H22.6607V13.8793H25.7089V14.6469L27.8334 12.3232L25.7089 9.89586V10.7776ZM11.2994 8.35022H15.3944L16.3078 10.3523L17.1494 8.33984H27.7718L28.8802 9.57428L30.0194 8.33984H34.8944L31.292 12.3336L34.8636 16.2963H29.9065L28.7981 15.0618L27.6486 16.2963H10.3244L9.82151 15.0618H8.66178L8.15888 16.2963H4.15625L7.52257 8.33984H11.0326L11.2994 8.35022ZM20.177 9.47055H17.8781L16.3386 13.1324L14.676 9.47055H12.3976V14.4498L10.2834 9.47055H8.24099L5.79836 15.1759H7.38914L7.89204 13.9415H10.5707L11.0736 15.1759H13.8652V11.0992L15.6613 15.1759H16.8826L18.6684 11.1096V15.1759H20.1668L20.177 9.47055ZM29.7423 12.3336L32.3389 9.47055H30.471L28.8289 11.2548L27.2381 9.47055H21.2034V15.1863H27.156L28.8084 13.3813L30.3991 15.1863H32.3184L29.7423 12.3336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_6361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexCard);
export default __webpack_public_path__ + "static/media/amex-card.c4f03ab45f8c0e70fb7031e482bd664f.svg";
export { ForwardRef as ReactComponent };